import ChooseSubscription from "./ChooseSubscription";
import SelectNumberOfPackages from "./SelectNumberOfPackages";
import Invoice from "./Invoice";
import AboCardBill from "./AboCardBill";
import CustomerService from "./CustomerService";
import YourAdvantages from "./YourAdvantages";
import CompletePurchase from "./CompletePurchase";
function ContentStep2(props) {
  // const handleStep2 = (value) => {
  //   // handleStep2 logic here
  //   console.log("contentstep2", value);
  //   props.step2(value);
  // };
  // const handleStep3 = (value) => {
  //   // handleStep2 logic here
  //   console.log("contentstep2", value);
  //   props.step3(value);
  // };

  const handleStep = (value) => {
    props.handleStep(value);
  };

  return (
    <div className="step-content">
      <div className="wrapper">
        <div className="column-left">
          <ChooseSubscription />
          <SelectNumberOfPackages />
          <div className="show-on-mobile">
            <AboCardBill />
          </div>
          <Invoice handleStep={handleStep} />
          <CompletePurchase handleStep={handleStep} />
        </div>
        <div className="column-right">
          <div className="hide-on-mobile">
            <AboCardBill />
          </div>
          <div className="hide-on-mobile">
            <CustomerService />
          </div>
          <div className="hide-on-mobile">
            <YourAdvantages />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ContentStep2;
